<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="buttonTabs"></ng-container>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
            <tt-button-goto ttText="sellers_new" ttGoto="seller" [ttGotoParms]="{ seller_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="sellers" [ttFilter]="page.filtervalue" [ttGoto]="false" [ttButtons]="rowButtons" (ttClick)="openItem($event)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-6 p-5" ttHeading="h_sellers"></tt-card>

        <tt-card class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="buttonTabs"></ng-container>
        </tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="sellers_new" ttTextAlign="left" ttIconPullRight ttIcon="fas fa-plus" (ttClick)="createSeller($event)"></tt-button>
            </tt-card>
        </div>

        <tt-divider ttRememberId="sellers_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-list class="col-xs-12 p-5" [ttData]="sellers" [ttFilter]="page.filtervalue" [ttGoto]="false" [ttButtons]="rowButtons" (ttClick)="openItem($event)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-seller *ngIf="sellerId" class="col-xs-12 p-5" [sellerId]="sellerId" (onSave)="updateList()"></tt-seller>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<ng-template #buttonTabs>
    <ng-container *ngIf="!!page">
        <tt-tabs ttRememberId="w_sellers.gb_sellers_main" [ttSelectedId]="page.gb_sellers_main" (ttSelectedIdChange)="changeTab($event)">
            <tt-tab ttId="ACTIVE" ttLabel="gb_sellers_main_active"></tt-tab>
            <tt-tab ttId="NOTACTIVE" ttLabel="gb_sellers_main_notactive"></tt-tab>
            <tt-tab ttId="ALL" ttLabel="gb_sellers_main_all"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!page">
        <tt-select ttRememberId="w_sellers.businessco_no" ttLabel="businessco" [ttModel]="page.businessco_no" (ttModelChange)="changeCompany($event)" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-input ttRememberId="w_sellers.filtervalue" ttLabel="filtervalue" ttFocus="false" [(ttModel)]="page.filtervalue" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>
